﻿import { IressPanel } from '@iress-oss/ids-components';
import { FC, ReactElement } from 'react';
import '../../styles/Navigation.css';

export const Navigation: FC = (): ReactElement => (
    <IressPanel stretch noBorderRadius background="page">
        <nav aria-label="Pension switching navigation">
            <div data-testid="navigation-menu" className="xps-navigation-menu">
                Menu will go here
            </div>
        </nav>
    </IressPanel>
);
